(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-show-tab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-category-show-tab-script');
    if (!window.categoryShowTab && $url) {
      window.categoryShowTab = $url.value;
      var $script = document.createElement('script');
      $script.src = window.categoryShowTab;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_ifa-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      if (window.secondaryProductCards && window.secondaryProductCards !== 'undefined' && window.secondaryProductCards.trim() !== '') {
        var $script = document.createElement('script');
        $script.src = window.secondaryProductCards;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      if (window.infoCarousel && window.infoCarousel !== 'undefined' && window.infoCarousel.trim() !== '') {
        var $script = document.createElement('script');
        $script.src = window.infoCarousel;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      if (window.imageSliders && window.imageSliders !== 'undefined' && window.imageSliders.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window.imageSliders
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg_secondary-product-cards-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      if (window.imageTab && window.imageTab !== 'undefined' && window.imageTab.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window.imageTab
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-main-product-v2-script');
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value;
      if (window.productV2 && window.productV2 !== 'undefined' && window.productV2.trim() !== '') {
        var $script = document.createElement('script');
        $script.src = window.productV2;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }
  })();



//const doc_locale = document.documentElement.lang;
/*
function updateButton() {
  const btn = document.querySelector('.as-async-add-form button');

  if (!btn) return;

  if (btn.textContent.trim() === 'Notify Me When Back in Stock') {
    if(window.Shopify.locale=='de') {  btn.textContent = 'Benachrichtige mich'; }
    else if(window.Shopify.locale=='fr') {  btn.textContent = 'Prévenez-moi'; }
    else if(window.Shopify.locale=='it') {  btn.textContent = 'Avvisami'; }
    else if(window.Shopify.locale=='es') {  btn.textContent = 'Notificarme'; }
    else {  btn.textContent = 'Notify Me'; }
  }
}

function updateKlaviyoPopup() {
  const form = document.querySelector('[data-testid^="klaviyo-form-"]');
  if (!form) return;

  // title
  const title = form.querySelector('[id^="rich-text-"] span');
  if (title) title.textContent = 'Join Waitlist';

  // placeholder
  const input = form.querySelector('input[type="email"]');
  if (input) input.placeholder = 'Enter your email';

  // button
  const button = form.querySelector('button[type="button"]');
  if (button) button.textContent = 'Join Now';
}

// run once for existing elements
updateButton();
updateKlaviyoPopup();

const btnObserver = new MutationObserver(() => {
  updateButton();
  updateKlaviyoPopup();
});

btnObserver.observe(document.body, {
  childList: true,      // element replaced
  subtree: true,        // deep watch
  characterData: true   // text changed
});
*/

function getLocaleText() {
  const locale = window.Shopify?.locale || 'en';

  const text = {
    de: {
      notify: 'Benachrichtige mich',
      title: 'Benachrichtigen Sie uns, sobald der Artikel wieder verfügbar ist',
      placeholder: 'Geben Sie Ihre E-Mail-Adresse ein',
      button: 'Benachrichtige mich'
    },
    fr: {
      notify: 'Prévenez-moi',
      title: 'Être prévenu(e) du retour en stock',
      placeholder: 'Saisissez votre adresse e-mail',
      button: "Prévenez-moi"
    },
    it: {
      notify: 'Avvisami',
      title: 'Avvisami quando torna disponibile',
      placeholder: 'Inserisci il tuo indirizzo email',
      button: 'Avvisami'
    },
    es: {
      notify: 'Notificarme',
      title: 'Avísame cuando vuelva a estar disponible',
      placeholder: 'Introduce tu correo electrónico',
      button: 'Notificarme'
    },
    en: {
      notify: 'Notify Me',
      title: 'Notify When Back in Stock',
      placeholder: 'Enter your email address',
      button: 'Notify Me'
    }
  };

  return text[locale] || text.en;
}

function updateUI() {
  const t = getLocaleText();

  // replace product button
  const btn = document.querySelector('.as-async-add-form button');
  if ( btn && btn.textContent.replace(/\s+/g, ' ').trim() === 'Notify Me When Back in Stock' ) {
    btn.textContent = t.notify;
  }
  /*
  // replace Klaviyo popup
  const form = document.querySelector('[data-testid="modal-form-container"]');

  console.log('........ [data-testid="modal-form-container"] : form available : ' + form)

  if (form) {
    const title = form.querySelector('[id^="rich-text-"] span');
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="button"]');
    
    if (title && title.textContent.replace(/\s+/g, ' ').trim() === 'Notify When Back in Stock') {
      title.textContent = t.title;
    }

    if (input && input.placeholder.replace(/\s+/g, ' ').trim() === 'Enter your email address') {
      input.placeholder = t.placeholder;
    }

    if (button && button.textContent.replace(/\s+/g, ' ').trim() === 'Notify Me') {
      button.textContent = t.button;
    }
  }
  */
}

// run once
updateUI();

// one observer only
new MutationObserver(updateUI).observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      if (window.productV2 && window.productV2 !== 'undefined' && window.productV2.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window.productV2
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      if (window.productV2 && window.productV2 !== 'undefined' && window.productV2.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window.productV2
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v4"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      if (window.productV2 && window.productV2 !== 'undefined' && window.productV2.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window.productV2
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-cs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-cards-script')
    if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
      window.imageCards = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.imageCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primary-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-primary-product-cards-script');
    if (!window.primaryProductCards && $url) {
      window.primaryProductCards = $url.value;
      if (window.primaryProductCards && window.primaryProductCards !== 'undefined' && window.primaryProductCards.trim() !== '') {
        var $script = document.createElement('script');
        $script.src = window.primaryProductCards;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      if (window.infoCarousel && window.infoCarousel !== 'undefined' && window.infoCarousel.trim() !== '') {
        var $script = document.createElement('script');
        $script.src = window.infoCarousel;
        $script.defer = 'defer';
        document.body.appendChild($script);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-promotion"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-product-promotion-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-product-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }

    var $url2 = document.querySelector('.as-info-carousel-script');
    if (!window.infoCarousel && $url2) {
      window.infoCarousel = $url2.value;
      var $script = document.createElement('script');
      $script.src = window.infoCarousel;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      if (window._stairs && window._stairs !== 'undefined' && window._stairs.trim() !== '') {
        var $script = document.createElement('script')
        $script.src = window._stairs
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
